<div class="CeEmptyState" [ngClass]="[size !== 'xs' ? 'u-border-secondary u-border-radius-md' : '', 'CeEmptyState--' + size]">
    @if (icon) {
    <ce-icon [svgIcon]="icon" class="CeEmptyState-icon"></ce-icon>
    } @if (size !== 'xs') {
    <ng-content select="h1[ce-empty-state-title], h2[ce-empty-state-title]"></ng-content>
    }
    <ng-content select="p[ce-empty-state-description]"></ng-content>
    @if (!actionRefresh && actionHref && actionLabel && size !== 'xs') {
    <a ce-link-button [href]="actionHref" class="u-spacing-xl-mb">{{ actionLabel }}</a>
    } @if (actionRefresh && size !== 'xs') {
    <button ce-link-button (click)="refreshPage()">Refresh page</button>
    }
    <ng-content></ng-content>
</div>
